module.exports = __webpack_public_path__ + "img/create_reading_plan.63029574.png";